import type { FeatureAvailabilityFragment } from 'generated/resources/graphql'
import { GetFeatureAvailabilitiesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface DefaultFeatureAvailabilityType {
  _internalType: 'feature'
  available: boolean
  id: string
  module?: string
  usage?: number
  currencyCode?: string
  usageLimit?: number
  additionalUnitPrice?: number
}

export type FeatureAvailabilityType = FeatureAvailabilityFragment | DefaultFeatureAvailabilityType

// Get the feature availability for the current company or a specific one.
//
// - Get if an specific feature is available.
//    `useFeatureAvailability('expenses_monthly_managed_expenses')`
// - Get the feature availability for a specific company
//    `useFeatureAvailability('payroll_management', companyId)`
/**
 * @deprecated Please include this query into the Page query
 */
export const useFeatureAvailability = (featureId: string, companyId?: string) => {
  const { loading, data, refetch } = useQuery(GetFeatureAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      modules: [],
      ids: [featureId],
      companyId,
    },
  })

  const featureAvailability: FeatureAvailabilityType = data?.companies.featureAvailabilities[0] ?? {
    available: false,
    id: featureId,
    _internalType: 'feature',
  }

  return {
    loading,
    refetch,
    featureAvailability,
  }
}
